var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item-group',[_c('sidebar-item',{key:_vm.favourites.path,attrs:{"item":_vm.favourites,"base-path":_vm.favourites.path,"common":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }